export default "__VITE_ASSET__BC3hJ1XN__"